import { safelyParseJSON } from '@egr/xbox/utils/Json';

function getBase64Padding(value: string): string {
    switch (value.length % 4) {
        case 2:
            return '==';
        case 3:
            return '=';
        default:
            return '';
    }
}

export function decodeJWTPayloadWithoutValidation<T = Record<string, unknown>>(data: string): T | undefined {
    const [, payload, ] = data.split('.');
    const padding: string = getBase64Padding(data);
    const jsonData = window.atob(payload + padding);
    return safelyParseJSON(jsonData);
}